import { Button } from "@material-ui/core";
import React from "react";
import "./Mbutton.scss";
import MbuttonProps from "./Mbutton.types";

const Mbutton = (props: MbuttonProps) => (
  <Button {...props} className="Mbutton-wrapper">
    {props.children}
  </Button>
);

export default Mbutton;
